import React from "react";
import { StyledTableRow } from "./styles";

function TableRow(props) {
    return <StyledTableRow {...props} />;
}

export default TableRow;
